import styled from 'styled-components';
import { Card, CardProps } from '../Card/Card';
import { standardTransitionStyles } from '../../sharedStyles';

export type ProgressCardProps = CardProps & {
  /**
   * Progress bar configuration with current and total values
   */
  progressBar: { current: number; total: number };
  /**
   * Whether to show the final success state
   */
  finalState?: boolean;
};

const ProgressBarContainer = styled.div`
  width: 100%;
  height: var(--border-radius-large);
  background: var(--purple-200);
  border-radius: var(--border-radius-medium) var(--border-radius-medium) 0 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

const ProgressBarFill = styled.div<{ $percent: number }>`
  height: 100%;
  background: var(--purple-700);
  width: ${({ $percent }) => $percent}%;
  transition: ${standardTransitionStyles};
`;

/**
 * ProgressCard component that displays a card with a progress bar.
 * This component wraps the Card component and adds progress bar functionality.
 */
export const ProgressCard = ({ children, progressBar, ...cardProps }: ProgressCardProps) => {
  const progressPercent = Math.max(0, Math.min(100, (progressBar.current / progressBar.total) * 100));

  return (
    <Card {...cardProps}>
      <ProgressBarContainer>
        <ProgressBarFill $percent={progressPercent} />
      </ProgressBarContainer>
      {children}
    </Card>
  );
};

export default ProgressCard;
